import type { AppStep } from '@/types/app';

export const ROUTES: Record<AppStep, string> = {
  dashboard: '/',
  upload: '/upload',
  crop: '/crop',
  production: '/production',
  complete: '/complete',
  product: '/product',
  products: '/products',
  settings: '/settings',
};

export function getRouteForStep(step: AppStep): string {
  return ROUTES[step] || '/';
}
